import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Form, Button, Message, Segment, Header } from 'semantic-ui-react';
import { useAuth } from '../contexts/AuthContext';
import FormInput from '../components/common/FormInput';

function Auth() {
  const navigate = useNavigate();
  const { login, register } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
  });

  const handleChange = (e, { name, value }) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isLogin) {
        await login(formData);
      } else {
        await register(formData);
      }
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - {isLogin ? 'Sign In' : 'Sign Up'}</title>
      </Helmet>

      <Container>
        <Segment padded="very">
          <Header as="h2" textAlign="center">
            {isLogin ? 'Sign In' : 'Create Account'}
          </Header>

          <Form onSubmit={handleSubmit} error={!!error}>
            {!isLogin && (
              <FormInput
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            )}

            <FormInput
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <FormInput
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              required
            />

            {error && <Message error content={error} />}

            <Button
              type="submit"
              primary
              fluid
              loading={loading}
              disabled={loading}
            >
              {isLogin ? 'Sign In' : 'Sign Up'}
            </Button>
          </Form>

          <Message>
            {isLogin ? "Don't have an account? " : "Already have an account? "}
            <Button
              type="button"
              link
              onClick={() => setIsLogin(!isLogin)}
            >
              {isLogin ? 'Sign Up' : 'Sign In'}
            </Button>
          </Message>
        </Segment>
      </Container>
    </>
  );
}

export default Auth; 